import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import type { AiqDifficultyAnalysis } from '../../types/aiq-report'

interface Props {
  data: AiqDifficultyAnalysis[]
}

export function DifficultyBarChart({ data }: Props) {
  const chartData = data.map(d => ({
    name: `Lv.${d.difficultyLevel}`,
    'Pre-AIQ': Math.round(d.preAccuracy * 100),
    'Post-AIQ': Math.round(d.postAccuracy * 100),
    questions: d.totalQuestions,
  }))

  if (chartData.length === 0) {
    return (
      <div className="p-6 bg-white rounded-xl shadow-2xs border border-gray-100">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">난이도별 정답률 비교</h3>
        <p className="text-sm text-gray-500 text-center py-8">데이터가 없습니다</p>
      </div>
    )
  }

  return (
    <div className="p-6 bg-white rounded-xl shadow-2xs border border-gray-100">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">난이도별 정답률 비교</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
          <XAxis dataKey="name" tick={{ fontSize: 13 }} />
          <YAxis domain={[0, 100]} tick={{ fontSize: 12 }} tickFormatter={(v) => `${v}%`} />
          <Tooltip
            formatter={((value: number, name: string) => [`${value}%`, name]) as never}
            labelFormatter={(label) => `${label} (${chartData.find(d => d.name === label)?.questions || 0}문제)`}
          />
          <Legend wrapperStyle={{ fontSize: 13 }} />
          <Bar dataKey="Pre-AIQ" fill="#3b82f6" radius={[4, 4, 0, 0]} />
          <Bar dataKey="Post-AIQ" fill="#8b5cf6" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
